/* Iris Academia — press and hold a swatch to see it larger.
   Any element with data-ia-zoom="<image url>" opens a full-screen view after a long press (touch or mouse);
   data-ia-zoom-detail adds a second, close-up image and data-ia-zoom-label a caption. A short tap still selects. */
(function () {
  if (window.IrisZoom) return;
  var HOLD = 450, MOVE = 10;
  var timer = null, startX = 0, startY = 0, suppressClick = false, overlay = null;

  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }

  function close() {
    if (!overlay) return;
    overlay.remove(); overlay = null;
    document.removeEventListener('keydown', onKey);
  }
  function onKey(e) { if (e.key === 'Escape') close(); }

  function open(el) {
    close();
    var src = el.getAttribute('data-ia-zoom'), detail = el.getAttribute('data-ia-zoom-detail'), label = el.getAttribute('data-ia-zoom-label') || '';
    overlay = document.createElement('div');
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', label);
    overlay.style.cssText = 'position:fixed;inset:0;z-index:120;background:rgba(26,14,7,0.82);display:flex;flex-direction:column;align-items:center;justify-content:center;gap:14px;padding:24px;box-sizing:border-box;cursor:zoom-out;animation:ia-zoom-in .18s ease;';
    overlay.innerHTML =
      '<button type="button" aria-label="Close" style="position:absolute;top:18px;right:18px;width:42px;height:42px;border-radius:50%;background:rgba(244,240,232,0.92);border:none;cursor:pointer;color:#3B2417;font-size:22px;line-height:1;">&times;</button>' +
      '<img src="' + esc(src) + '" alt="' + esc(label) + '" style="max-width:min(92vw,720px);max-height:' + (detail ? '62vh' : '78vh') + ';object-fit:contain;box-shadow:0 20px 70px rgba(0,0,0,0.5);">' +
      (detail ? '<img src="' + esc(detail) + '" alt="" style="width:min(42vw,200px);aspect-ratio:1/1;object-fit:cover;border:2px solid rgba(244,240,232,0.85);box-shadow:0 10px 30px rgba(0,0,0,0.4);">' : '') +
      (label ? '<p style="margin:0;font-family:\'Cormorant\',serif;font-size:22px;color:#F4F0E8;letter-spacing:0.02em;text-align:center;">' + esc(label) + '</p>' : '');
    overlay.addEventListener('click', close);
    document.body.appendChild(overlay);
    document.addEventListener('keydown', onKey);
  }

  function cancel() { if (timer) { clearTimeout(timer); timer = null; } }

  document.addEventListener('pointerdown', function (e) {
    var el = e.target.closest && e.target.closest('[data-ia-zoom]');
    if (!el || (e.pointerType === 'mouse' && e.button !== 0)) return;
    cancel();
    startX = e.clientX; startY = e.clientY;
    timer = setTimeout(function () { timer = null; suppressClick = true; open(el); }, HOLD);
  }, true);
  document.addEventListener('pointermove', function (e) {
    if (timer && (Math.abs(e.clientX - startX) > MOVE || Math.abs(e.clientY - startY) > MOVE)) cancel();
  }, true);
  ['pointerup', 'pointercancel', 'scroll'].forEach(function (t) { document.addEventListener(t, cancel, true); });
  // the long press opened the view: the click that follows must not also pick the swatch
  document.addEventListener('click', function (e) {
    if (!suppressClick) return;
    suppressClick = false;
    if (e.target.closest && e.target.closest('[data-ia-zoom]')) { e.preventDefault(); e.stopPropagation(); }
  }, true);
  document.addEventListener('contextmenu', function (e) {
    if (e.target.closest && e.target.closest('[data-ia-zoom]')) e.preventDefault();
  }, true);

  var st = document.createElement('style');
  st.textContent = '[data-ia-zoom]{-webkit-touch-callout:none;-webkit-user-select:none;user-select:none;}@keyframes ia-zoom-in{from{opacity:0;}to{opacity:1;}}';
  document.head.appendChild(st);

  window.IrisZoom = { open: open, close: close };
})();
